export default class Service {
  private static element?: Element;

  public constructor(element?: Element) {
    if (element) { // use this element in all other Service objects
      Service.element = element;
    }
  }

  // eslint-disable-next-line class-methods-use-this
  public get tagName(): string {
    return Service.element?.tagName.toLowerCase() ?? 'unknown';
  }

  public log(message: string, ...args: unknown[]): void {
    console.log(`${this.tagName}:`, message, ...args); // eslint-disable-line no-console
  }

  public logInfo(message: string, ...args: unknown[]): void {
    console.info(`${this.tagName}:`, message, ...args); // eslint-disable-line no-console
  }

  public logError(message: string | Error, ...args: unknown[]): void {
    console.error(`${this.tagName}:`, message, ...args); // eslint-disable-line no-console
  }

  public fireEvent<T>(details: T): void {
    const event = new CustomEvent<T>(this.tagName, {
      bubbles: true,
      composed: true, // pass through shadow DOM boundaries
      detail: details,
    });
    Service.element?.dispatchEvent(event);
  }
}
